<template>
  <g :transform="`translate(${x}, ${y})`">
    <polygon
      v-if="left"
      fill="#9d9fa2"
      :points="leftPolygon"
    />
    <rect
      v-if="back"
      fill="url(#holes_bg)"
      :x="xOffset"
      :y="-yOffset"
      :width="width"
      :height="height"
    />
    <rect
      v-if="front"
      fill="url(#holes_bg)"
      :x="0"
      :y="0"
      :width="width"
      :height="height"
    />
    <polygon
      v-if="right"
      fill="#9d9fa2"
      :points="rightPolygon"
    />
  </g>
</template>

<script>
  export default {
    name: 'Rack',
    props: {
      width: Number,
      height: Number,
      x: Number,
      y: Number,
      left: Boolean,
      right: Boolean,
      front: Boolean,
      back: Boolean,
    },
    computed: {
      xOffset() {
        return this.width / 1.8;
      },
      yOffset() {
        return this.width / 3;
      },
      leftPolygon() {
        return `${this.xOffset},${this.height - this.yOffset}
            0,${this.height}
            0,0
            ${this.xOffset},${-this.yOffset}`;
      },
      rightPolygon() {
        return `${this.width + this.xOffset},${this.height - this.yOffset}
            ${this.width},${this.height}
            ${this.width},0
            ${this.width + this.xOffset},${-this.yOffset}`;
      },
    },
  };
</script>
